export default __webpack_public_path__ + "static/media/mobility_simulation_not_found.37c88659.svg";